export type RuntimeConfig = {
  apiUrl: string;
  keycloakUrl: string;
  invitationsDevMode?: boolean;
  keycloakRealm: string;
  keycloakClientId: string;
  oidcAuthority: string;
  oidcClientId: string;
  oidcScopes: string;
  baseHref: string;
  adminGroupName: string;
  avUrl: string;
  appPrivacyPolicyVersion: string;
  ursulaUnlimitedQuota: number;
  appVersion: string;
  maintenanceMode: boolean;
  maintenanceMessageDe: string;
  maintenanceMessageEn: string;
  maintenanceBannerMessageDe: string;
  maintenanceBannerMessageEn: string;
  maintenanceBannerVisibleFrom: string;
  maintenanceBannerVisibleUntil: string;
};

declare global {
  interface Window {
    __RUNTIME_CONFIG__?: Partial<RuntimeConfig>;
  }
}

const cfg =
  (typeof window !== "undefined" ? window.__RUNTIME_CONFIG__ : undefined) ?? {};

const asString = (value: unknown, fallback = ""): string =>
  typeof value === "string" && value.length > 0 ? value : fallback;

const asNumber = (value: unknown, fallback: number): number =>
  typeof value === "number" ? value : fallback;

const asBoolean = (value: unknown, fallback: boolean): boolean =>
  typeof value === "boolean" ? value : fallback;

export const runtimeConfig: RuntimeConfig = {
  apiUrl: asString(cfg.apiUrl),
  keycloakUrl: asString(cfg.keycloakUrl),
  invitationsDevMode:
    typeof cfg.invitationsDevMode === "boolean"
      ? cfg.invitationsDevMode
      : false,
  keycloakRealm: asString(cfg.keycloakRealm),
  keycloakClientId: asString(cfg.keycloakClientId),
  oidcAuthority: asString(cfg.oidcAuthority),
  oidcClientId: asString(cfg.oidcClientId),
  oidcScopes: asString(cfg.oidcScopes),
  baseHref: asString(cfg.baseHref, "/"),
  adminGroupName: asString(cfg.adminGroupName),
  avUrl: asString(cfg.avUrl),
  appPrivacyPolicyVersion: asString(cfg.appPrivacyPolicyVersion),
  ursulaUnlimitedQuota: asNumber(cfg.ursulaUnlimitedQuota, -1),
  appVersion: asString(cfg.appVersion),
  maintenanceMode: asBoolean(cfg.maintenanceMode, false),
  maintenanceMessageDe: asString(cfg.maintenanceMessageDe),
  maintenanceMessageEn: asString(cfg.maintenanceMessageEn),
  maintenanceBannerMessageDe: asString(cfg.maintenanceBannerMessageDe),
  maintenanceBannerMessageEn: asString(cfg.maintenanceBannerMessageEn),
  maintenanceBannerVisibleFrom: asString(cfg.maintenanceBannerVisibleFrom),
  maintenanceBannerVisibleUntil: asString(cfg.maintenanceBannerVisibleUntil),
};

// Export URSULA quota constant for easy access
export const URSULA_UNLIMITED_QUOTA = runtimeConfig.ursulaUnlimitedQuota;
